Customer.Users ||= {}

class Customer.Users.UserProfileView extends Backbone.View

  template: JST["backbone/templates/customer/users/user_profile_modal"]

  events:
    'click #contents-tab': 'onShowContents'
    'click #conversations-tab': 'onShowTickets'
    'click #external-tickets-tab': 'onShowExternalTickets'
    'click #clone': '_cloneDashboard'
    'shown.bs.tab': '_addButtonCreateNewSesion'
    'click #user-profile': 'onOperatorAction'

  initialize: (@options = {}) ->
    @dashboard = @options.dashboard
    @session = @options.session
    @socialId = @options.id
    @source = @options.source

  render: ->
    @$el.html(@template())
    @$el.on('hidden', => @$el.remove())
    @legendPresent = false
    this

  show: ->
    @$el.find('#user-profile').modal()
    @doGetProfile()

  renderResponse: (response) =>
    @response = response
    if response.profile
      @profileId = response.id
      @editableAttributes = response.editable_attributes
      @$el.find('.tab-content').html('')
      @renderMainProfile(response)
      @renderConversationsTab(response)
      @renderContentsTab(response)
      @renderMergeTab(response)
      @renderExternalTicketsTab(response) if Keepcon.currentAccount.customer.externalTicketsEnabled
      @$el.find('#user-profile .nav-tabs li').removeClass('active')
      @$el.find('#user-profile .nav-tabs li').first().addClass('active')
      @$el.find('#nano-user-profile.processing').removeClass('processing')
      @_onSetTab(@options.openTab) if @options.openTab?
    else
      @showError()

  renderMainProfile: (response) ->
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false })
    for socialUser in response.social_users
      @searchQuery.addSocialNetworkId(
        value: socialUser.social_network_id
        name: socialUser.values.name
      )
    response.profile.id = response.id
    @mainProfileView = new Customer.Users.ProfileMainView({
      source: @source
      profile: response.profile,
      social_users: response.social_users,
      ticket_social_user_id: @socialId,
      editable_attributes: response.editable_attributes,
      search_query: @searchQuery
    })
    @mainProfileView.bind('profile:social-user-removed', @renderAfterSocialUserAddedOrRemoved)
    @listenTo @mainProfileView, 'profile_custom_attributes:change', (response) =>
      @trigger 'profile_custom_attributes:change', response
      @response = response
      @$el.find('.tab-content').empty()
      @renderResponse(@response)
    @listenTo @mainProfileView, 'profile_custom_attributes:restore', =>
      @$el.find('.tab-content').empty()
      @renderResponse(@response)
    @$el.find('.tab-content').append(@mainProfileView.render().el)
    @mainProfileView.afterRender()
    @$el.find('#sort_asc.fa-arrow-circle-up, #sort_desc.fa-arrow-circle-down').hide()
    @$el.find('.insert-note').hide()

  renderConversationsTab: (response) ->
    @$el.find('#conversations-tab').removeClass('hidden')
    socialUserIds = _.map(response.social_users, (su) -> "#{su.source}-#{su.social_network_id}")
    @conversationsView = new Customer.Users.ProfileConversationsView(ids: socialUserIds)
    @$el.find('.tab-content').append @conversationsView.el

  renderMergeTab: (response) ->
    profile = @_userProfileFromResponse()
    return unless profile
    @$el.find('#merge-tab').removeClass('hidden')
    @profileMerger = new Customer.Users.ProfileMergerView({profile: profile})
    @profileMerger.bind('mergeSuccess', @renderAfterSocialUserAddedOrRemoved)
    @$el.find('.tab-content').append(@profileMerger.render().el)

  renderAfterSocialUserAddedOrRemoved: (response)=>
    @trigger('profile:attributes-updated', response)
    @renderResponse(response)

  renderContentsTab: (response) ->
    @$el.find('#contents-tab').removeClass('hidden')
    contentsView = new Customer.Users.ProfileContentsView({searchQuery: @searchQuery})
    @$el.find('.tab-content').append(contentsView.render().el)
    contentsView.newSearch()

  renderExternalTicketsTab: (response) ->
    profile = @_userProfileFromResponse()
    @$el.find('#external-tickets-tab').removeClass('hidden')
    @externalTicketsView = new Customer.Users.ExternalTicketsView({profile: profile})
    @$el.find('.tab-content').first().append(@externalTicketsView.render().el)

  doGetProfile: =>
    source = if @source.toUpperCase().includes('LIVEFYRE') then 'livefyre' else @source
    if I18n.t('google_play.user.anonymous') == @id && source == "google_play"
      @showError()
    else
      _socialId = encodeURIComponent(@socialId)
      $.ajax
        type: 'GET'
        url: "/profiles/api/#{source}/#{_socialId}"
        success: @renderResponse
        error: @showError


  showError: =>
    errorMsg = $("<div>#{I18n.t('user_profiles.cant_be_loaded')}</div>").addClass('profile-error')
    @$el.find('#nano-user-profile.processing').removeClass('processing').html(errorMsg)

  onShowTickets: =>
    unless @conversationsView.hasContents
      @conversationsView.search()

  onShowContents: =>
    for el in @$el.find('.tweet-top')
      $el = $(el)
      $el.find('.user-profile-links').removeClass('user-profile-links')
    if !@legendPresent && @$el.find('.some-contents').children().length >= 5
      @$el.find('.some-contents').prepend('<div><span style="font-family: \'Roboto\'; margin-left: 15px;">These are the last five contents</span></div>')
      @legendPresent = true

  onShowExternalTickets: ->
    @externalTicketsView.getExternalTickets()

  _cloneDashboard: ->
    @$el.find('.modal').modal('hide')
    @eventAggregator.trigger('clickOnCloneDashboard', @searchQuery)

  _addButtonCreateNewSesion: ->
    if @$el.find('ul.nav.nav-tabs li.active').attr('id') == 'contents-tab'
      @$el.find('.modal-footer.modal-profile').append('<button id="clone" type="button" class="btn btn-primary" data-toggle="button">Create new session</button>')
    else
      @$el.find('#clone').remove()


  _onSetTab: (tabName) =>
    @$el.find('#user-profile .nav-tabs li').removeClass('active')
    @$el.find("#user-profile .nav-tabs li##{tabName}").addClass('active')
    @conversationsView.search() if tabName == 'conversations-tab'
    @onShowExternalTickets() if tabName == 'external-tickets-tab'
    section = @$el.find("#user-profile .nav-tabs li.active a").attr('href')
    @$el.find('.tab-content div.tab-pane').removeClass('active')
    @$el.find(".tab-content div#{section}").addClass('active')

  _userProfileFromResponse: =>
    return null unless @response
    new Profile.UserProfile.ExtendedUserProfile @response

  onOperatorAction: ->
    @_keepCustomerSessionAlive()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
